<div class="notification" [ngClass]="[isVisible ? 'visible': '']" [ngStyle]="{'backgroundColor': data.color}">
  <div class="notification__icon" *ngIf="data.icon.length">
    <brt-icon [icon]="data.icon"></brt-icon>
  </div>
  <div class="notification__text" aria-live="assertive" role="alert">{{data.text}}</div>
</div>
